import { createAction, updateAction } from '@ac/library-utils/dist/redux-utils';

import { UpdateComplementaryDetailsPayload } from './interfaces/actionPayloads';

export const clearRegistrationCardEditComplementary = createAction(
  '@registrationCardEditComplementary/clearRegistrationCardEditComplementary'
);

export const updateComplementaryDetails = updateAction<
  UpdateComplementaryDetailsPayload,
  undefined
>('@registrationCardEditComplementary/updateComplementaryDetails');
